import {createSlice} from "@reduxjs/toolkit";

export const initialState = {
    currentPage: 1,
    pageSize: 30,
    selectedCategoryId: null,
    selectedTeacherId: null,
};

export const actCompletionWorkTableControllerSlice = createSlice({
    name: 'actCompletionWorkTableControllerSlice',
    initialState,
    reducers: {
        changeCurrentPage(state, action) {
            state.currentPage = action.payload.page;
            state.pageSize = action.payload.pageSize;
        },
        changeSelectedCategoryId(state, action) {
            state.selectedCategoryId = action.payload;
            state.currentPage = 1;
        },
        changeSelectedTeacherId(state, action) {
            state.selectedTeacherId = action.payload;
            state.currentPage = 1;
        },
    },
});

export const { changeCurrentPage, changeSelectedCategoryId, changeSelectedTeacherId } = actCompletionWorkTableControllerSlice.actions;

export default actCompletionWorkTableControllerSlice.reducer;
